import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=7df0025c&scoped=true&"
import script from "./ClientSelect.vue?vue&type=script&lang=js&"
export * from "./ClientSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelect.vue?vue&type=style&index=0&id=7df0025c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df0025c",
  null
  
)

export default component.exports